// Preferences that used to live on the DeepAdmin profile endpoint and are now
// device-local. The string values still match the former profile keys, because
// the one-off migration in localPreferences reads the profile blob by name.
export enum LocalPreferenceKeys {
  VIEW_OPTION = 'viewOption',
  EXPERT_SETTINGS = 'expertSettings',
  QUORUM_CONTROL = 'quorumControl',
  LAST_SELECTED_ORG = 'lastSelectedOrg',
  DOCUMENTS_WIZARDS = 'documentsWizards',
  CREATED_DATE_ORDER = 'createdDateOrder'
}
